var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ae-icon',{attrs:{"type":"edit"}}),_c('ae-icon',{staticClass:"m-l",attrs:{"type":"close-circle"}}),_c('ae-icon',{staticClass:"m-l",attrs:{"type":"delete"}}),_c('ae-icon',{staticClass:"m-l",attrs:{"type":"plus"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }